// This file is compiled inside Decidim core pack. Code can be added here and will be executed
// as part of that pack

import "src/consultations_question_requirements_validator";
import "src/cas_href_replacement";

// Load images
require.context("../../images", true);

